import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Button, Checkbox, Stack, Typography, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useTranslation } from 'react-i18next';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const ITEM_HEIGHT = 48;

export default function FuelTypeDropdown({ onDone, slectedTypes }) {
  const theme = useTheme();
  const { fuelTypes } = useSelector((state) => state.layout);
  const [checkList, setCheckList] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const {t} = useTranslation()

  React.useEffect(() => {
    setCheckList(slectedTypes || []);
  }, [slectedTypes]);
  const ref = React.useRef(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event) => {
    if (event.target.checked === true) {
      setCheckList([...checkList, event.target.value]);
    } else {
      const selectedAcc = checkList.filter((a) => {
        if (a === event.target.value) return false;
        return true;
      });

      setCheckList([...selectedAcc]);
    }
  };
  const handleSelectAll = (event) => {
    if (event.target.checked === true) {
      setCheckList(fuelTypes.map((res) => res.fuelType));
    } else {
      setCheckList([]);
    }
  };

  const handleDone = () => {
    onDone(fuelTypes.filter((res) => checkList.includes(res.fuelType)));
    setAnchorEl(null);
  };

  return (
    <div>
      <Stack
        ref={ref}
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        className="h-[48px] px-4 !mb-4 rounded-[4px] !pr-[5px]"
        justifyContent={'space-between'}
        direction={'row'}
        alignItems={'center'}
        sx={{
          border: '1px solid rgba(0,0,0,0.23)',
          cursor: 'pointer',
        }}
      >
        <Typography
          color="rgba(0, 0, 0, 0.64)"
          className="ff-Roboto text-base !capitalize"
        >
          {t('Fuel type')} *
        </Typography>

        {!open ? (
          <ArrowDropDownIcon
            color="#64717C"
            className="!ml-[60px]"
            style={{ color: '#64717C' }}
          />
        ) : (
          <ArrowDropUpIcon
            color="#64717C"
            className="!ml-[60px]"
            style={{ color: '#64717C' }}
          />
        )}
      </Stack>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 6,
            width: ref?.current?.offsetWidth,
          },
        }}
      >
        <Stack>
          <Stack
            alignItems="center"
            direction="row"
            className="h-[48px]"
          >
            <Stack flex={2}>
              <Checkbox
                onChange={handleSelectAll}
                {...label}
                size="small"
              />
            </Stack>
            <Stack flex={8}>
              <Typography
                className="fw-regular ff-Roboto fs-12 "
                color={theme.palette.primary.textLight}
              >
                {t('Fuel')}
              </Typography>
            </Stack>
            <Stack flex={4}>
              <Typography
                className="fw-regular ff-Roboto fs-12 !capitalize"
                color={theme.palette.primary.textLight}
              >
                {t('Emission factor')}
              </Typography>
            </Stack>
          </Stack>
          {(fuelTypes || []).map((item, index) => (
            <Stack
              key={index}
              direction="row"
              className="h-[48px]"
            >
              <Stack flex={2}>
                <Checkbox
                  value={item?.fuelType}
                  {...label}
                  checked={checkList.lastIndexOf(item?.fuelType) >= 0 ? true : false}
                  onChange={handleChange}
                  size="small"
                />
              </Stack>
              <Stack flex={8}>
                <Typography
                  className="fw-regular ff-Roboto fs-14 "
                  color={theme.palette.primary.text}
                >
                  {item?.fuelType}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-10 "
                  color={theme.palette.primary.textLight}
                >
                  {t('Reference: ISO 8218 Grades RME through RMX')}
                </Typography>
              </Stack>
              <Stack flex={4}>
                <Typography
                  className="fw-regular ff-Roboto fs-14 "
                  color={theme.palette.primary.text}
                >
                  {item?.emissionFactor}
                </Typography>
              </Stack>
            </Stack>
          ))}
        </Stack>
        <Stack
          alignItems="flex-start"
          justifyContent="center"
          className="sticky bottom-0 left-0 bg-white h-[56px] pl-4 z-10"
        >
          <Button
            onClick={handleDone}
            disabled={checkList.length == 0}
            variant="text"
          >
            {t('Done')}
          </Button>
        </Stack>
      </Menu>
    </div>
  );
}
